import { req ,importFile} from './axiosFun';
/**
 * 大型设备管理
 **/

// 查看所有大型设备预约信息
export const qryEntranceList = (params) => { return req("post", "/yishantong-ui/equipment/qryEntranceList", params) };

// 修改大型设备预约状态
export const upEntranceStatus = (params) => { return req("post", "/yishantong-ui/equipment/upEntranceStatus", params) };

// 修改大型设备预约车辆数据
export const upCars = (params) => { return req("post", "/yishantong-ui/equipment/upCars", params) };

// 修改大型设备信息数据
export const upEnts = (params) => { return req("post", "/yishantong-ui/equipment/upEnts", params) };

//提前结束预约
export const upStatusEnd = (params) => { return req("post", "/yishantong-ui/equipment/upEnd", params) };




// WEBPACK FOOTER //
// ./src/api/examApi.js